<div class="load-indicator-container" *ngIf="loading; else loaded">
  <p>{{ translation?.loading }}</p>
  <abc-load-indicator></abc-load-indicator>
</div>

<ng-template #loaded>
  <div class="message-container" *ngIf="resultsEmpty || !data; else showNestedGrid">
    <p *ngIf="!loading">
      {{ translation?.resultMessage.clickMessage }} '{{ translation?.resultMessage.button }}'
      <span class="dx-icon dx-icon-fieldchooser"></span>{{ translation?.resultMessage.viewMessage }}
    </p>
  </div>

  <ng-template #showNestedGrid>
    <abc-opath-queries-editor-nested-grid
      #nestedGrid
      *ngIf="data"
      [data]="data"
      [query]="query"
      [level]="0"
    ></abc-opath-queries-editor-nested-grid>
  </ng-template>
</ng-template>
